export function logError(
  error: Error,
  info: { componentStack?: string | null }
) {
  if (import.meta.env.VITE_APP_IS_DEV !== 'false') {
    console.log("Caught error:", error);
    console.log("Error details:", info);
  } else {
    // Log error to an external service in production
  }
}
